/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvoucherexpired2Inputs */

const en_dropvoucherexpired2 = /** @type {(inputs: Dropvoucherexpired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

const de_dropvoucherexpired2 = /** @type {(inputs: Dropvoucherexpired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelaufen`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Dropvoucherexpired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvoucherexpired2 = /** @type {((inputs?: Dropvoucherexpired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvoucherexpired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvoucherexpired2(inputs)
	return de_dropvoucherexpired2(inputs)
});
export { dropvoucherexpired2 as "dropVoucherExpired" }